import { Link } from "react-router-dom";
import { trackEvent } from "@/lib/analytics";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[500px] md:min-h-[600px] flex flex-col md:flex-row" aria-labelledby="hero-heading">
      {/* Left - Green */}
      <div className="flex-1 bg-[#5cb85c] flex items-center justify-center py-16 md:py-0 px-6">
        <div className="text-center text-white max-w-md">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-light leading-snug mb-6">
            Post a project, you would
            <br />
            Be assigned a hacker
          </h2>
          <Link
            to="/post-project"
            onClick={() => trackEvent("post_project_click", { source: "hero_section" })}
            className="inline-block bg-[#0d1117]/20 hover:bg-[#0d1117]/30 text-white text-sm font-semibold px-6 py-3 rounded transition-all whitespace-nowrap cursor-pointer"
          >
            Post a Project
          </Link>
        </div>
      </div>

      {/* Right - Blue */}
      <div className="flex-1 bg-[#5bc0de] flex items-center justify-center py-16 md:py-0 px-6">
        <div className="text-center text-white max-w-md">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-light leading-snug mb-6">
            Check each Hacker&apos;s
            <br />
            Profile, select the best for you
          </h2>
          <Link
            to="/hackers"
            className="inline-block bg-[#0d1117]/20 hover:bg-[#0d1117]/30 text-white text-sm font-semibold px-6 py-3 rounded transition-all whitespace-nowrap cursor-pointer"
          >
            Find a Hacker
          </Link>
        </div>
      </div>
    </section>
  );
}